enum ChartActionId {
  DOWNLOAD = 'chartDownloadOptions',
  FULLSCREEN = 'chartFullscreenOptions',
  INTERVAL = 'chartIntervalAction',
  TIMEZONE = 'chartTimezoneOptions',
  TREND = 'chartTrendOptions',
  TYPE = 'chartTypeOptions',
}

export default ChartActionId;
